import { Component, Inject, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IFornecedor } from '@app/modules/fornecedor/models/fornecedor.model';
import { FornecedorService } from '@app/modules/fornecedor/services/fornecedor.service';
import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import { SELECT } from '@app/shared/components';
import { validateCnpj, validateCpf } from '@app/shared/utils';
import { companyValidationMessages } from '@app/shared/validation.message';
import { of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CustomValidators,
  Pattern,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';

@Component({
  selector: 'app-fast-fornecedor',
  templateUrl: './fast-fornecedor.component.html',
  styleUrls: ['./fast-fornecedor.component.scss'],
  providers: [FornecedorService, ParceiroService]
})
export class FastFornecedorComponent {
  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  crtOptions: SELECT[] = [
    { viewValue: 'Microempreendedor Individual (MEI)', value: 'MEI' },
    { viewValue: 'Simples nacional', value: 'SIMPLES_NACIONAL' },
    { viewValue: 'SN c/ Exc. Rec. Bruta', value: 'SN_EXC_REC_BRUTA' },
    { viewValue: 'Regime normal', value: 'REGIME_NORMAL' }
  ];

  form: UntypedFormGroup;

  viewInit = false;
  findParceiro = false;
  cpfCnpjMask = '000.000.000-00*';

  entity: IFornecedor = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as IFornecedor;

  messages = companyValidationMessages;

  constructor(
    public dialogRef: MatDialogRef<FastFornecedorComponent>,
    public fornecedorService: FornecedorService,
    private tokenService: TokenService,
    private parceiroService: ParceiroService,
    public snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) private data: { entity: IFornecedor }
  ) {}

  ngOnInit() {
    this.entity = this.data.entity;
    this.form = this.fb.group({});
    this.form = this.fb.group(
      this.usaFiscal
        ? {
            nome_razao_social: [
              this.entity.parceiro.nome_razao_social,
              [
                Validators.required,
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            apelido_nome_fantasia: [
              this.entity.parceiro.apelido_nome_fantasia,
              [
                Validators.minLength(1),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            cpf_cnpj: [
              this.entity.parceiro.cpf_cnpj,
              [Validators.required]
            ],
            rg_insc_est: [
              this.entity.parceiro.rg_insc_est,
              [
                Validators.pattern(Pattern.patternInscEstadual()),
                Validators.maxLength(20),
                CustomValidators.existSpecialChar(),
                CustomValidators.isEmptyValue()
              ]
            ],
            desconto: [
              this.entity.desconto,
              [
                Validators.required,
                CustomValidators.validateCurrencyValues(15,2),
                CustomValidators.existSpecialChar(true)
              ]
            ],
            crt: [this.entity.crt], // [Validators.required]],
            validar_limite_credito: [this.entity.validar_limite_credito || false] //[Validators.required],
          }
        : {
            nome_razao_social: [
              this.entity.parceiro.nome_razao_social,
              [
                Validators.required,
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            apelido_nome_fantasia: [
              this.entity.parceiro.apelido_nome_fantasia,
              [
                Validators.minLength(1),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            cpf_cnpj: [
              this.entity.parceiro.cpf_cnpj,
              [Validators.required]
            ],
            rg_insc_est: [
              this.entity.parceiro.rg_insc_est,
              [
                Validators.pattern(Pattern.patternInscEstadual()),
                Validators.maxLength(20),
                CustomValidators.existSpecialChar(),
                CustomValidators.isEmptyValue()
              ]
            ],
            desconto: [
              this.entity.desconto,
              [
                Validators.required,
                CustomValidators.validateCurrencyValues(15,2),
                CustomValidators.existSpecialChar(true)
              ]
            ],
            validar_limite_credito: [this.entity.validar_limite_credito || false] //[Validators.required],
          }
    );

    this.checkRgInscEstadual();

    this.form.controls.cpf_cnpj.valueChanges.subscribe(value => {
      if (value) {
        this.validar();
        this.setMask();
      }
    });
  }

  validar() {
    let cpfCnpjValue = this.form.controls.cpf_cnpj.value;
    if (cpfCnpjValue.toString().length <= 11) {
      if (validateCpf(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
        this.form.updateValueAndValidity();
      }
    } else {
      if (validateCnpj(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
        this.form.updateValueAndValidity();
      }
    }
  }

  setMask() {
    if (this.form.controls.cpf_cnpj.value) {
      if (this.form.controls.cpf_cnpj.value.toString().length <= 11)
        this.cpfCnpjMask = '000.000.000-00*';
      else {
        this.cpfCnpjMask = '00.000.000/0000-00';
      }
    }
  }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this.form.valid;
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.form.invalid) this.form.markAllAsTouched();
    return this.viewInit && this.form.invalid;
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;
    if (
      rgInsc.value === null ||
      rgInsc.invalid ||
      rgInsc.value === '' ||
      this.findParceiro
    )
      return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe((parceiro: IParceiro) => {
        if (parceiro[0] && parceiro[0].id) {
          this.form.controls.rg_insc_est.setErrors({ duplicate: true });
          this.form.updateValueAndValidity();
          return {} as IParceiro;
        }
      });
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (cpfCnpj.invalid) return;
    const cpfCnpjValue: string = cpfCnpj.value;

    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros => {
          if (parceiros.length) {
            this.findParceiro = true;
            return { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() };
          } else {
            this.findParceiro = false;
            return {} as IParceiro;
          }
        }),
        mergeMap(parceiro => {
          if (parceiro === undefined)
            return of(parceiro);
          return this.fornecedorService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return {} as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe((parceiro: IParceiro) => {
        if(parceiro === undefined) return;
        else if(Object.keys(parceiro).length !== 0){
          this.setInformacoesParceiro(parceiro);
          this.form.patchValue({
            apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
            nome_razao_social: parceiro.nome_razao_social || null,
            rg_insc_est: parceiro.rg_insc_est || null,
            data_nascimento: null
          });
        }
      });
  }

  getValuesParceiro(): any {
    const {
      nome_razao_social,
      apelido_nome_fantasia,
      cpf_cnpj,
      rg_insc_est
    } = this.form.value as IParceiro;

    return Utils.trimAttributes({
      nome_razao_social,
      apelido_nome_fantasia,
      cpf_cnpj,
      rg_insc_est
    });
  }

  getValuesFornecedor(): any {
    const { desconto, crt } = this.form.value as IFornecedor;

    var desc = Utils.replaceCommaToDot(desconto);

    return Utils.trimAttributes({
      domain_id: this.tokenService.getDomain().id,
      desconto: desc,
      crt
    });
  }

  onSubmit(): void {
    var entity: IFornecedor = Utils.clearObject<IFornecedor>({
      ...this.entity,
      ...this.getValuesFornecedor(),
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this.getValuesParceiro(),
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      })
    } as IFornecedor);
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    this.insert(entity);
  }

  insert(entity: IFornecedor): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.fornecedorService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, fornecedor]) => {
            return this.fornecedorService.getEntity(fornecedor.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          fornecedor => {
            this.snackBar.open('Fornecedor criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(fornecedor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.fornecedorService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(fornecedor => {
            return this.fornecedorService.getEntity(fornecedor.id, [
              'parceiro'
            ]);
          })
        )
        .subscribe(
          fornecedor => {
            this.snackBar.open('Fornecedor criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(fornecedor);
          },
          () => {
            this.snackBar.open('Ops, estamos com problemas.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  get usaFiscal() {
    return localStorage.getItem('usaFiscal') === 'true';
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }
}
